import styled from "styled-components";

export const Background = styled.div`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  display: ${(props) => !props.show && "none"};
  z-index: 2;
`;

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background-color: var(--second-auxiliary-color);
  position: absolute;
  overflow: hidden;
  bottom: ${(props) => (props.open ? `${props.index * 5}rem` : "0")};
  transition: bottom 0.5s;
  z-index: -1;
  display: ${(props) => (props.hidden ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  color: var(--primary-bg-color);
  font-size: 2rem;
  cursor: pointer;
  box-shadow: 0px 0px 8px 0px var(--second-auxiliary-color);

  &:hover {
    transform: scale(1.1);
  }
`;

export const MenuButton = styled.div`
  cursor: pointer;
  display: grid;
  gap: 5px;
  align-items: center;
  border-radius: 50%;
  padding: 15px;
  width: 56px;
  height: 56px;
  justify-content: center;
  transition: background-color 0.5s;
  background-color: var(--second-auxiliary-color);
  box-shadow: 0px 0px 8px 0px var(--second-auxiliary-color);
  grid-template-areas:
    ". . ."
    ". . ."
    ". . .";

  &:hover {
    transform: scale(1.1);
  }

  /** Animação do ícone
  */
  div {
    width: 6px;
    height: 6px;
    border-radius: 1px;
    background-color: var(--primary-bg-color);

    &:nth-child(2) {
      transform-origin: 50% 14px;
      transition: transform 0.5s;
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(4) {
      transform-origin: 14px 50%;
      transition: transform 0.5s;
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(5) {
      transform-origin: center;
      transition: transform 0.5s;
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(6) {
      transform-origin: -8px 50%;
      transition: transform 0.5s;
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(8) {
      transform-origin: 50% -8px;
      transition: transform 0.5s;
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
    }

    &:nth-child(1) {
      transform-origin: center;
      transition: ${(props) =>
        props.open ? "transform 0.5s" : "transform 0.5s ease 0.5s"};
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};

      div {
        transform-origin: top left;
        transition: ${(props) =>
          props.open ? "transform 0.5s ease 0.5s" : "transform 0.5s"};
        transform: ${(props) => (props.open ? "scaleX(3.2)" : "scaleX(0)")};
      }
    }

    &:nth-child(3) {
      transform-origin: center;
      transition: ${(props) =>
        props.open ? "transform 0.5s" : "transform 0.5s ease 0.5s"};
      transform: ${(props) => (props.open ? "rotate(-45deg)" : "rotate(0)")};

      div {
        transform-origin: top right;
        transition: ${(props) =>
          props.open ? "transform 0.5s ease 0.5s" : "transform 0.5s"};
        transform: ${(props) => (props.open ? "scaleX(3.2)" : "scaleX(0)")};
      }
    }

    &:nth-child(7) {
      transform-origin: center;
      transition: ${(props) =>
        props.open ? "transform 0.5s" : "transform 0.5s ease 0.5s"};
      transform: ${(props) => (props.open ? "rotate(-45deg)" : "rotate(0)")};

      div {
        transform-origin: top left;
        transition: ${(props) =>
          props.open ? "transform 0.5s ease 0.5s" : "transform 0.5s"};
        transform: ${(props) => (props.open ? "scaleX(3.2)" : "scaleX(0)")};
      }
    }

    &:nth-child(9) {
      transform-origin: center;
      transition: ${(props) =>
        props.open ? "transform 0.5s" : "transform 0.5s ease 0.5s"};
      transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};

      div {
        transform-origin: top right;
        transition: ${(props) =>
          props.open ? "transform 0.5s ease 0.5s" : "transform 0.5s"};
        transform: ${(props) => (props.open ? "scaleX(3.2)" : "scaleX(0)")};
      }
    }
  }
`;
